import { create } from 'zustand'

interface UIState {
  sidebarOpen: boolean
  theme: 'light' | 'dark'
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
  setTheme: (theme: 'light' | 'dark') => void
}

// Default sidebar state based on screen size
const getDefaultSidebarState = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth >= 768 // md breakpoint
  }
  return true
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: getDefaultSidebarState(),
  theme: 'light',

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  setTheme: (theme) => set({ theme })
}))
